module.exports = __webpack_public_path__ + "img/tech-spec.6dd62e15.svg";